import {ActionBarBehavior} from "../action-bar-behavior";
import {Injectable} from "@angular/core";
import {BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {ActionBarConfig} from "../../../../model/action-bar-config";
import {Subject, Subscription} from "rxjs";
import {ActionBarType} from "../../../../constants/action-bar-type.enum";
import * as _ from "lodash";

@Injectable()
export class CloseMeterDataActionBarBehavior extends ActionBarBehavior {
  ngUnsubscribe: Subject<boolean> = new Subject<boolean>();
  subscriptions: Subscription[] = [];

  config: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  constructor(
    private dialogService: BsModalService,
  ) {
    super();
  }

  executeAction(actionBarConfig: ActionBarConfig, selectedRecords?: any[], additionalParams?: any) {
    const actionNewConfig = _.find(actionBarConfig.buttonBarConfigs, conf => conf.actionBarType === ActionBarType.CLOSING_METER_DATA);
    const bsModalRef = this.dialogService.show(actionBarConfig.closingMeterDataForm, {
      ...this.config,
      initialState: actionBarConfig.initState
    });
    bsModalRef.setClass(actionNewConfig.customClass ? actionNewConfig.customClass : `modal-dialog-centered ${additionalParams.customModal}`);
  }

  isActionBar(type: ActionBarType): boolean {
    return ActionBarType.CLOSING_METER_DATA === type;
  }

}
